module.exports = __webpack_public_path__ + "img/map-hours-table-black.e8ed36ff.png";